var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00245d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ael-fan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.845 83.571 0.761 100.255 64.378 113.061 62.049 106.073 10.845 83.571"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.155 146.419 229.239 129.735 165.622 116.939 167.951 123.927 219.155 146.419"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.262 111.601 0.839 130.335 65.603 126.236 61.542 120.088 6.262 111.601"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.738 118.389 229.162 99.675 164.397 103.774 168.459 109.912 223.738 118.389"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.091 139.871 8.693 159.354 70.194 138.632 64.683 133.753 9.091 139.871"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "220.91 90.129 221.307 70.646 159.806 91.368 165.317 96.247 220.91 90.129"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.135 166.422 23.795 185.355 77.828 149.427 71.254 146.139 19.135 166.422"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.866 63.569 206.205 44.635 152.167 80.572 158.747 83.861 210.866 63.569"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.711 189.493 45.113 206.567 88.007 157.874 80.797 156.395 35.711 189.493"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "194.289 40.507 184.885 23.433 141.993 72.125 149.203 73.605 194.289 40.507"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.694 207.467 71.191 221.531 100.023 163.393 92.678 163.842 57.694 207.467"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.307 22.523 158.807 8.468 129.977 66.607 137.322 66.157 172.307 22.523"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.582 219.152 100.256 229.239 113.061 165.622 106.079 167.951 83.582 219.152"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.419 10.848 129.74 0.761 116.939 64.378 123.922 62.049 146.419 10.848"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.606 223.731 130.327 229.169 126.229 164.402 120.086 168.45 111.606 223.731"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "118.389 6.259 99.673 0.831 103.772 65.597 109.912 61.549 118.389 6.259"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.866 220.912 159.357 221.302 138.632 159.814 133.748 165.322 139.866 220.912"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.134 9.088 70.643 8.688 91.366 70.186 96.252 64.678 90.134 9.088"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.432 210.865 185.355 206.207 149.423 152.167 146.132 158.754 166.432 210.865"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.569 19.134 44.641 23.793 80.577 77.833 83.869 71.246 63.569 19.134"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "189.488 194.281 206.562 184.885 157.867 141.99 156.395 149.208 189.488 194.281"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.512 35.708 23.438 45.115 72.128 88.009 73.605 80.802 40.512 35.708"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.474 172.309 221.532 158.804 163.393 129.975 163.837 137.322 207.474 172.309"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.526 57.69 8.469 71.196 66.6 100.025 66.163 92.678 22.526 57.69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFan);
export default __webpack_public_path__ + "static/media/logo-fan.38ecda09.svg";
export { ForwardRef as ReactComponent };